"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearUserService = void 0;
var tslib_1 = require("tslib");
var settings_1 = require("./settings");
var UsersConverter_1 = require("../../convertors/fromBackend/UsersConverter");
var BearUserService = /** @class */ (function () {
    function BearUserService(authCall) {
        this.authCall = authCall;
    }
    BearUserService.prototype.settings = function () {
        return new settings_1.BearUserSettingsService(this.authCall);
    };
    BearUserService.prototype.getUser = function () {
        var _this = this;
        return this.authCall(function (sdk) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var accountSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdk.user.getCurrentProfile()];
                    case 1:
                        accountSettings = _a.sent();
                        return [2 /*return*/, UsersConverter_1.convertUser(accountSettings)];
                }
            });
        }); });
    };
    return BearUserService;
}());
exports.BearUserService = BearUserService;
//# sourceMappingURL=index.js.map